import {
  GET_ITEMSTATUS_REQUEST,
  GET_ITEMSTATUS_SUCCESS,
  GET_ITEMSTATUS_FAILURE,
  GET_ITEM_TYPE_REQUEST,
  GET_ITEM_TYPE_SUCCESS,
  GET_ITEM_TYPE_FAILURE,
  GET_ITEM_TYPE_DOWNLOAD_REQUEST,
  GET_ITEM_TYPE_DOWNLOAD_SUCCESS,
  GET_ITEM_TYPE_DOWNLOAD_FAILURE,
  GET_ITEM_STATUS_DOWNLOAD_REQUEST,
  GET_ITEM_STATUS_DOWNLOAD_SUCCESS,
  GET_ITEM_STATUS_DOWNLOAD_FAILURE,
} from "./itemStatusTypes";
import axios from "axios";
import Config from "../../../config/index";
let baseUrl = Config.baseUrl;

const getItemStatusRequest = () => {
  return {
    type: GET_ITEMSTATUS_REQUEST,
  };
};

const getItemStatusSuccess = (payload) => {
  return {
    type: GET_ITEMSTATUS_SUCCESS,
    payload: payload,
  };
};

const getItemStatusFailure = (error) => {
  return {
    type: GET_ITEMSTATUS_FAILURE,
    payload: error,
  };
};

const getItemStatus = (
  pageNo,
  rowsPerPage,
  search,
  selectedItemType,
  selectedItemCode,
  selectedLocation,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getItemStatusRequest());
    // let url = `${baseUrl}/reports/item_status?type=${selectedItemType}&itemCode=${selectedItemCode}&locationId=${selectedLocation}`;
    let url = `${baseUrl}/reports/item_status?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&type=${selectedItemType}&itemCode=${selectedItemCode}&locationId=${selectedLocation}`;
  
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getItemStatusSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getItemStatusFailure(err.response));
      });
  };
};
const getItemStatusDownloadRequest = () => {
  return {
    type: GET_ITEM_TYPE_DOWNLOAD_REQUEST,
  };
};

const getItemStatusDownloadSuccess = (payload) => {
  return {
    type: GET_ITEM_TYPE_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getItemStatusDownloadFailure = (error) => {
  return {
    type: GET_ITEM_TYPE_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getItemStatusDownload = (
  pageNo,
  rowsPerPage,
  search,
  selectedItemType,
  selectedItemCode,
  selectedLocation,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getItemStatusDownloadRequest());
    // let url = `${baseUrl}/reports/item_status?type=${selectedItemType}&itemCode=${selectedItemCode}&locationId=${selectedLocation}`;
    let url = `${baseUrl}/reports/item_status?download=1&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&type=${selectedItemType}&itemCode=${selectedItemCode}&locationId=${selectedLocation}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getItemStatusDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getItemStatusDownloadFailure(err.response));
      });
  };
};

const getItemTypesForStatusRequest = () => {
  return {
    type: GET_ITEM_TYPE_REQUEST,
  };
};

const getItemTypesForStatusSuccess = (payload) => {
  return {
    type: GET_ITEM_TYPE_SUCCESS,
    payload: payload,
  };
};

const getItemTypesForStatusFailure = (error) => {
  return {
    type: GET_ITEM_TYPE_FAILURE,
    payload: error,
  };
};

const getItemTypesForStatus = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getItemTypesForStatusRequest());
    let url = `${baseUrl}/itemtype`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getItemTypesForStatusSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getItemTypesForStatusFailure(err.response));
      });
  };
};


const downloadItemStatusRequest = () => {
  return {
    type: GET_ITEM_STATUS_DOWNLOAD_REQUEST,
  };
};

const downloadItemStatusSuccess = (payload) => {
  return {
    type: GET_ITEM_STATUS_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const downloadItemStatusFailure = (error) => {
  return {
    type: GET_ITEM_STATUS_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const downloadItemStatus = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  selectedItemType,
  selectedItemCode,
  selectedLocation,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadItemStatusRequest());
    let url = `${baseUrl}/reports/item_status?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&type=${selectedItemType}&itemCode=${selectedItemCode}&locationId=${selectedLocation}`;
    
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadItemStatusSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadItemStatusFailure(err.response));
      });
  };
};

export { getItemStatus, getItemTypesForStatus ,getItemStatusDownload,downloadItemStatus};
